// Half-second window either side of a comment's timestamp during which its
// marker (orb) is on screen.
export const COMMENT_THRESHOLD_MS = 0.5;

/**
 * Comment markers visible for the current playhead position.
 *
 * A marker shows while `time` is within COMMENT_THRESHOLD_MS of the comment's
 * timestamp. `pinnedCommentId` is the one exception: selecting a comment in the
 * drawer does not seek the player, so the focused comment is also drawn over
 * the current frame — but only while the playhead is parked where it was when
 * the comment was selected. Once playback moves on the caller drops the pin, so
 * an edited comment's orb disappears just like a newly created one's.
 *
 * @param {Object} params
 * @param {Array} params.comments
 * @param {number} params.time current playhead position, in seconds
 * @param {string} [params.pinnedCommentId] focused comment to keep on screen
 *
 * @return {Array}
 */
function getCommentsToRender({ comments = [], time, pinnedCommentId }) {
  const isRenderable = ({ commentId, isRejected }) => commentId && !isRejected;

  const withinWindow = comments.filter(
    (comment) => isRenderable(comment) &&
    time <= comment.timestamp + COMMENT_THRESHOLD_MS &&
    time >= comment.timestamp - COMMENT_THRESHOLD_MS
  );

  if (
  !pinnedCommentId ||
  withinWindow.some(({ commentId }) => commentId === pinnedCommentId))
  {
    return withinWindow;
  }

  return [
  ...withinWindow,
  ...comments.filter(
    (comment) => isRenderable(comment) && comment.commentId === pinnedCommentId
  )];

}

export default getCommentsToRender;
